import apiEndpoints from '../../const/apiEndpoints'
import api from '../../services'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  Course,
  GetChildCoursesPayload,
  GetChildCoursesResponse,
  GetChildByInstitutePayload,
  GetMaterialByTopicPayload,
  GetMaterialByTopicResponse,
  GetCoursesResponse,
  GetAllCoursesPayload,
  GetAllCoursesResponse,
  CourseDetails,
  CoursePayload,
  CourseResponse,
  EditCoursePayload
} from './types'
import strings from '../../locale/en'
import history from '../../const/history'
import ROUTES from '../../const/routes'
import { getClearCourse, getClearMaterial } from '../learnSession/api'

export const getAllCoursesByInstitute = createAsyncThunk(
  'course/getAllCoursesByInstitute',
  async (coachingCentreId: string): Promise<Array<Course>> => {
    const response = await api.get(
      `${apiEndpoints.getAllCoursesByInstitute}?coachingCentreId=${coachingCentreId}`
    )
    return response?.data
  }
)

export const getChildCourses = createAsyncThunk(
  'course/getChildCourses',
  async ({
    courseId,
    type
  }: GetChildCoursesPayload): Promise<GetChildCoursesResponse> => {
    const { data } = await api.get(`${apiEndpoints.getChildCourse}${courseId}`)
    return { response: data?.data, type }
  }
)

export const getChildByInstitute = createAsyncThunk(
  'course/getChildByInstitute',
  async ({
    instituteId,
    branchId
  }: GetChildByInstitutePayload): Promise<GetChildCoursesResponse> => {
    const url = branchId
      ? `${apiEndpoints.getCourses}?coachingCentreId=${instituteId}&branchId=${branchId}`
      : `${apiEndpoints.getCourses}?coachingCentreId=${instituteId}`

    const { data } = await api.get(url)
    return data
  }
)

export const getMaterialByTopic = createAsyncThunk(
  'course/getMaterialByTopic',
  async ({
    topicId
  }: GetMaterialByTopicPayload, { dispatch }): Promise<GetMaterialByTopicResponse> => {
    const { data } = await api.post(
      `${apiEndpoints.getMaterialByTopic}${topicId}`
    )
    if (data.data) {
      dispatch(getClearMaterial())
    }
    return { materials: data?.data }
  }
)

export const getCourses = createAsyncThunk(
  'course/getCourses',
  async (): Promise<GetCoursesResponse> => {
    const { data } = await api.get(
      `${apiEndpoints.getCourse}?coachingCentreId=`
    )
    return { coursesToAddMaterial: data }
  }
)

export const getAllCourses = createAsyncThunk(
  'course/getAllCourses',
  async ({
    pageNumber,
    pageSizeNumber,
    searchCriteria = {}
  }: GetAllCoursesPayload): Promise<GetAllCoursesResponse> => {
    const requestPayload = {
      pageNo: pageNumber,
      pageSize: pageSizeNumber,
      sortBy: 'created_at',
      ascDesc: 'Desc',
      searchCriteria
    }
    const { data } = await api.post(apiEndpoints.getAllCourses, requestPayload)
    return {
      courses: data,
      pageSize: pageSizeNumber,
      currentPage: pageNumber
    }
  }
)

export const getCourse = createAsyncThunk(
  'course/getCourse',
  async (): Promise<Array<CourseDetails>> => {
    const { data } = await api.get(apiEndpoints.getCourse)
    return data
  }
)

export const deleteCourse = createAsyncThunk(
  'course/deleteCourse',
  async (courseId: string, { dispatch }): Promise<void> => {
    const response = await api.delete(`${apiEndpoints.deleteCourse}${courseId}`)
    if (response?.data) {
      dispatch(
        getAllCourses({
          pageNumber: 1,
          pageSizeNumber: 10
        })
      )
      dispatch(getClearCourse())
    }
  }
)

export const editCourse = createAsyncThunk(
  'course/editCourse',
  async ({ courseId, payload }: EditCoursePayload, { dispatch }): Promise<CourseResponse> => {
    const {
      validationMessages: {
        course: { saveError }
      }
    } = strings

    const response = await api.put(
      `${apiEndpoints.editCourse}${courseId}`,
      payload
    )

    if (response?.data) {
      history.push(ROUTES.COURSELIST)
      dispatch(getClearCourse())
      return response?.data
    } else {
      return { error: saveError } as CourseResponse
    }
  }
)

export const saveCourse = createAsyncThunk(
  'course/saveCourse',
  async (payload: CoursePayload, { dispatch }): Promise<CourseResponse> => {
    const {
      validationMessages: {
        course: { saveError }
      }
    } = strings

    const response = await api.post(`${apiEndpoints.saveCourse}`, payload)
    if (response?.data) {
      history.push(ROUTES.COURSELIST)
      dispatch(getClearCourse())
      return response?.data
    } else {
      return { error: saveError } as CourseResponse
    }
  }
)
